export type AutoQualityAdjustorCpuMetrics = {
  autoQualityAdjustorCpuDowngradeCount: undefined | number;
  autoQualityAdjustorCpuUpgradeCount: undefined | number;
  autoQualityAdjustorCpuRecovered: undefined | boolean;
};

export const autoQualityAdjustorCpuMetrics: AutoQualityAdjustorCpuMetrics = {
  autoQualityAdjustorCpuDowngradeCount: undefined,
  autoQualityAdjustorCpuUpgradeCount: undefined,
  autoQualityAdjustorCpuRecovered: undefined,
};
